













































































import ripple from "./ripple.vue"
import tooltip from "./tooltip.vue"
import {JobItem} from "../routes/jobView.vue" 
import gbutton from "./button.vue"
import inlineTextEdit from "./inlineTextEdit.vue"
import popupDisplay from "./popupDisplay.vue"
import warningPopup, {WarningInterface} from "./warningPopup.vue"

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {nextTick} from "process";
import moment,{ weekdays, invalid} from "moment";

import { setInterval } from "timers";
import { frontendClient } from "../lib/client";
import dateSelector from "./dateSelector.vue";

export interface dayItem{
    dayOfWeek: number,
    date: Date,
    children: JobItem[],
    range: number, // 0=start, 1=mid, 2=end
}

@Component({
    components : {
        ripple,
        tooltip,
        gbutton,
        inlineTextEdit,
        popupDisplay
    },
})
export default class CalItem extends Vue{
    @Prop({}) item:JobItem;
    @Prop({}) parentDate:number; // unix of start of associated date
    @Prop({}) isSmall:boolean;

    @Prop({}) parentMoveDestination: string;

    startsBefore:boolean = false;
    endsAfter:boolean = false;

    isAdmin:boolean = false;
    dateRangeLoading:boolean = false;

    completeStages:number = 1; //0=none, 1=partial, 2=all

    // 0 = no date selected
    // 1 = this date selected
    // 2 = another date selected - prevent interaction
    shouldDisplayGroups:number = 0;
    parentDateString:string = (<any> new Date(this.parentDate)) as string;

    // MENU VALUES
    menuOpen:boolean = false;
    coords:{
        x:number,
        y:number
    }

    // DATE VALUES
    dateRange:{
        startDate:string;
        endDate:string;
    } = null;

    redirect(route,parameters){
        this.$router.push({ name: route, params: {jobID: parameters}});
    };

    calculateNextDay(start: number) {
        return moment(start).add(1,"day").toDate().getTime();
    }

    mounted(){
        this.resetBounds();
        this.startsEnds();
        this.getDate();
        this.beginRouteWatch();
        this.getCompletion();
        this.checkAdmin();
    }

    checkAdmin(){
        if(frontendClient.userData.rank == "admin"){
            this.isAdmin = true;
        }
    }

    cancelAllocation(){
        this.$route.params.activeWorkerName = null;
        this.$route.params.activeWorkerID = null;
        this.$route.params.allocating = null;
        this.$emit("allocatedStaff");
        window["calendarFocusChanged"]();
    }

    async allocate(group){

        this.shouldDisplayGroups = 0;
        if(!this.$route.params.activeWorkerID || !this.$route.params.activeWorkerName){
            return;
        }
        let groupID;
        if(group != null){
            groupID = group.id;
            for(let i=0;i<group.members.length;i++){
                if(group.members[i].id == this.$route.params.activeWorkerID){
                    nextTick(() => {
                        frontendClient.giveError("Already appointed here");
                        this.shouldDisplayGroups = 1;
                    })
                    return;
                }
            }
        }
        else {
            group = {
                members: [],
            };
            this.item.groups.push(group);

            groupID = (await frontendClient.postEx( "jobs/usergroups/new", {
                jobID: this.item.id,
                scheduledAt: this.parentDate,
            })).id;
            group.id = groupID;
        }

        nextTick(async () => {
            frontendClient.giveError("Saving...");
        })

        let memberIdx = group.members.push({
            name: this.$route.params.activeWorkerName,
        });

        await frontendClient.postEx("jobs/usergroups/adduser",{
            usergroupID: groupID,
            userID: this.$route.params.activeWorkerID,
        }).then(()=>{
            frontendClient.giveError("Saved");
            setTimeout(() => {
                frontendClient.clearError();
            },1000);
        });

        this.$route.params.activeWorkerName = null;
        this.$route.params.activeWorkerID = null;
        this.$route.params.allocating = null;
    }

    async deallocateMember(group,member) {
        nextTick(() => {
            frontendClient.giveError("Saving...");
        })

        if(frontendClient.userData.rank !== "admin") {return;}

        let memberIdx = group.members.indexOf(member);
        if(memberIdx !== -1) {
            group.members.splice(memberIdx,1);
        }

        await frontendClient.postEx("jobs/usergroups/removeuser",{
            usergroupID: group.id,
            userID: member.id,
        }).then(()=>{
            frontendClient.giveError("Saved");
            setTimeout(() => {
                frontendClient.clearError();
            },1000);
        });

        if(group.members.length == 0) {
            let groupIdx = this.item.groups.indexOf(group);
            if(groupIdx !== -1) {
                this.item.groups.splice(groupIdx,1);
            }
            await frontendClient.postEx("jobs/usergroups/delete",{
                id: group.id,
            });
        }
    }

    beginRouteWatch(){
        // this is done as @Watch($route.params.anything) doesnt trigger...
        setInterval(() => {
            if(this.$route.params.allocating == this.parentDateString){
                this.shouldDisplayGroups = 1;
            }else if(this.$route.params.allocating != null){
                this.shouldDisplayGroups = 2;
            }else{
                this.shouldDisplayGroups = 0;
            }
            
        },100)
    }

    getCompletion(){
        let anyComplete:boolean = false;
        let anyIncomplete:boolean = false;

        for(let i=0;i < this.item.groups.length;i++) {
            
            if(this.item.groups[i].complete == true){
                anyComplete = true;
            }
            if(this.item.groups[i].complete == false){
                anyIncomplete = true;
            }
        }

        if(anyComplete){
            if(anyIncomplete){
                this.completeStages = 1;
            }else{
                this.completeStages = 2;
            }
        }else{
            this.completeStages = 0;
        }
    }

    resetBounds(){
        this.startsBefore = false;
        this.endsAfter = false;
    }

    @Watch('item.endsAt')
    startsEnds(){
        let start = moment((this.item.startsAt + 1000)).format("DD/MM/YYYY");
        let end = moment((this.item.endsAt)).format("DD/MM/YYYY");
        let dateItemIsIn = moment(this.parentDate).format("DD/MM/YYYY");

        if(start != dateItemIsIn){
            this.startsBefore = true;
        }
        if(end != dateItemIsIn){
            this.endsAfter = true;
        }
    }
    @Watch('item.startsAt')
    callStartsEnds(){
        this.startsEnds();
    }

    getDate(){
        if(!this.item || this.item == undefined || this.item == null) return;
        this.dateRange = {
            startDate: moment(this.item.startsAt).format("DD/MM/YYYY"),
            endDate: moment(this.item.endsAt).format("DD/MM/YYYY")
        }
    }
    

    openPopupMenu(event){
        event.preventDefault();
        event.stopPropagation();
        nextTick(()=>{
            this.menuOpen = true;
            this.coords = {
                x: event.pageX,
                y: event.pageY,
            }
        })
    }
    closeMenu(){
        this.menuOpen = false;
    }

    async saveDate(){
        this.dateRangeLoading = true;
        if(this.completeStages > 0){
            nextTick(() => {
                frontendClient.giveError("Job is complete or partially complete - It cannot be moved");
            })
            return;
        }
        nextTick(() => {
            frontendClient.giveError("Saving...");
        })

        await frontendClient.postEx("jobs/edit",{
            id: this.item.id,

            startsAt: moment(this.dateRange.startDate,"DD/MM/YYYY").toDate().getTime(),
            endsAt: moment(this.dateRange.endDate,"DD/MM/YYYY").toDate().getTime(),
        }).then(()=>{
            frontendClient.giveError("Saved");
            setTimeout(() => {
                frontendClient.clearError();
            },1000);
            this.closeMenu();
            this.dateRangeLoading = false;
        }).catch(() => {
            this.dateRangeLoading = false;
        })
        
    }

    hasChildren(){
        if(this.item.groups.length > 0){
            return true;
        }else{
            return false;
        }
    }

    @Watch("parentMoveDestination")
    async setDay(newVal: Date,oldVal?: Date | Symbol) {
        // if(typeof oldVal !== "string") {return;}
        // if(typeof oldVal === "symbol") {return;}

        if(oldVal == null || (newVal).getTime() == (oldVal as Date).getTime()) return;

        frontendClient.giveError("Saving...");

        if(isNaN(newVal.getTime())) {
            await frontendClient.postEx("jobs/edit",{
                id: this.item.id,

                startsAt: "noday",
                endsAt: "noday",
            }).catch((err) => {
                frontendClient.giveError("Error saving date");
            })
        }
        else {
            await frontendClient.postEx("jobs/edit",{
                id: this.item.id,

                startsAt: newVal.getTime(),
                endsAt: this.calculateNextDay(newVal.getTime()) - 1,
            }).catch((err) => {
                frontendClient.giveError("Error saving date");
            })
        }

        window["calendarFocusChanged"]()
    }
}
